export default __webpack_public_path__ + "static/media/HV B2B Cat laminate.46da486a.jpg";